import { getPropertyOr } from '~/common/util/object';

import AlertDataModel from './AlertDataModel';

export default class RentalCalculationReviewBreakdownModel {
  calculationAmount: number;
  formulas: any[];
  calculatorType: string;
  alerts: AlertDataModel[];

  constructor(data = {}) {
    this.calculationAmount = getPropertyOr(data, 'calculationAmount', 0);

    this.formulas = getPropertyOr(data, 'formulas', []);

    this.calculatorType = getPropertyOr(data, 'incomeCalculatorTypeId', '');

    this.alerts = getPropertyOr(data, 'alerts', []).map(
      (alert) => new AlertDataModel(alert),
    );
  }

  getCalculationAmount() {
    return this.calculationAmount;
  }

  getFormulas() {
    return this.formulas[0];
  }

  getCalculatorType() {
    return this.calculatorType;
  }

  getAlerts() {
    return this.alerts;
  }
}
